module.exports = __webpack_public_path__ + "img/p53.a50edf15.png";